import {
  type FormData,
  type FormComponent,
  type GuestInfo,
  type Guests,
  COMPONENT_TYPE_GUEST,
} from '@entities/leadCollector';

export const getMainGuestFromBodyForm = (bodyForm: FormData | null | undefined): GuestInfo | null => {
  const guests = getGuestsFromBodyForm(bodyForm);
  return guests?.mainGuest ?? null;
};

export const getGuestsFromBodyForm = (bodyForm: FormData | null | undefined): Guests | null => {
  if (!bodyForm?.components?.length) return null;

  const guestComp = bodyForm.components.find((component: FormComponent) => component.type === COMPONENT_TYPE_GUEST);
  if (!guestComp?.properties) return null;

  return guestComp.properties as unknown as Guests;
};
